function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("polygon", {
  id: "path-1",
  points: "0 0.0206521739 19 0.0206521739 19 22.71735 0 22.71735"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\xCDbu\xF0-detail",
  transform: "translate(-1194.000000, -1167.000000)"
}, React.createElement("g", {
  id: "Group-15",
  transform: "translate(1194.000000, 1167.000000)"
}, React.createElement("g", {
  id: "Group-14"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.000000, 0.392474)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Clip-2"
}), React.createElement("path", {
  d: "M0.826086957,4.34765435 L0.826086957,2.08582826 C0.826086957,1.40265435 1.38204348,0.846697826 2.06521739,0.846697826 L16.9347826,0.846697826 C17.6179565,0.846697826 18.173913,1.40265435 18.173913,2.08582826 L18.173913,4.34765435 L0.826086957,4.34765435 Z M18.173913,20.6521326 C18.173913,21.3353065 17.6179565,21.891263 16.9347826,21.891263 L2.06521739,21.891263 C1.38204348,21.891263 0.826086957,21.3353065 0.826086957,20.6521326 L0.826086957,5.1737413 L18.173913,5.1737413 L18.173913,20.6521326 Z M16.9347826,0.0206108696 L2.06521739,0.0206108696 C0.924391304,0.0206108696 0,0.945415217 0,2.08582826 L0,20.6521326 C0,21.7929587 0.924391304,22.71735 2.06521739,22.71735 L16.9347826,22.71735 C18.0756087,22.71735 19,21.7929587 19,20.6521326 L19,5.1737413 L19,4.34765435 L19,2.08582826 C19,0.945415217 18.0756087,0.0206108696 16.9347826,0.0206108696 Z",
  id: "Fill-1",
  fill: "#88949D",
  mask: "url(#mask-2)"
})), React.createElement("path", {
  d: "M9.48955,7.23553043 C13.1524196,7.23553043 16.1325283,10.2156391 16.1325283,13.8785087 C16.1325283,17.5417913 13.1524196,20.5219 9.48955,20.5219 C5.82626739,20.5219 2.8461587,17.5417913 2.8461587,13.8785087 C2.8461587,10.2156391 5.82626739,7.23553043 9.48955,7.23553043 M9.48955,21.347987 C13.6080065,21.347987 16.9586152,17.9973783 16.9586152,13.8785087 C16.9586152,9.76005217 13.6080065,6.40944348 9.48955,6.40944348 C5.37068043,6.40944348 2.02007174,9.76005217 2.02007174,13.8785087 C2.02007174,17.9973783 5.37068043,21.347987 9.48955,21.347987",
  id: "Fill-4",
  fill: "#88949D"
}), React.createElement("path", {
  d: "M12.966137,13.8785087 C12.966137,15.3109435 12.0954413,16.5430522 10.8554848,17.0746391 L11.4733978,17.6925522 C12.8496587,16.9738565 13.7922239,15.5356391 13.7922239,13.8785087 C13.7922239,12.1172913 12.7278109,10.6018348 11.209463,9.93683478 C11.0107891,10.1375739 10.7947674,10.3552478 10.572963,10.5770522 C11.9603761,11.0334652 12.966137,12.3399217 12.966137,13.8785087",
  id: "Fill-6",
  fill: "#88949D"
}), React.createElement("path", {
  d: "M3.25920217,2.19309565 C2.80320217,2.19309565 2.43311522,2.56276957 2.43311522,3.01918261 C2.43311522,3.47518261 2.80320217,3.84526957 3.25920217,3.84526957 C3.71561522,3.84526957 4.08528913,3.47518261 4.08528913,3.01918261 C4.08528913,2.56276957 3.71561522,2.19309565 3.25920217,2.19309565",
  id: "Fill-8",
  fill: "#88949D"
}), React.createElement("path", {
  d: "M6.15050652,2.19309565 C5.69450652,2.19309565 5.32441957,2.56276957 5.32441957,3.01918261 C5.32441957,3.47518261 5.69450652,3.84526957 6.15050652,3.84526957 C6.60691957,3.84526957 6.97659348,3.47518261 6.97659348,3.01918261 C6.97659348,2.56276957 6.60691957,2.19309565 6.15050652,2.19309565",
  id: "Fill-10",
  fill: "#88949D"
}), React.createElement("path", {
  d: "M15.6505065,2.19309565 C15.1945065,2.19309565 14.8244196,2.56276957 14.8244196,3.01918261 C14.8244196,3.47518261 15.1945065,3.84526957 15.6505065,3.84526957 C16.1069196,3.84526957 16.4765935,3.47518261 16.4765935,3.01918261 C16.4765935,2.56276957 16.1069196,2.19309565 15.6505065,2.19309565",
  id: "Fill-12",
  fill: "#88949D"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "19px",
    height: "24px",
    viewBox: "0 0 19 24",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/washer.4b21b963.svg";
export { SvgComponent as ReactComponent };